import Link from "next/link";
import { useState, type FunctionComponent } from "react";
import { Translation } from "../../contexts/TranslationContext";
import type { ContentLinksItem } from "../../data/ContentFragment";
import style from "./ContentOutline.module.sass";
import { ShowMoreLessButton } from "./ShowMoreLessButton";

type ContentOutlineProps = {
	items: ContentLinksItem[] | undefined;
};

export const ContentOutline: FunctionComponent<ContentOutlineProps> = ({
	items,
}) => {
	if (!items || items.length <= 1) {
		return null;
	}

	const [isAllVisible, setIsAllVisible] = useState(false);
	const listedItems = isAllVisible ? items : items.slice(0, 5);

	return (
		<div className={style.root} id="contentOutline">
			<div className={style.title}>
				<Translation tr="content.summary.title" />
			</div>
			<ol className={style.list}>
				{listedItems.map((item) => (
					<li key={item.target} className={style.listItem}>
						<Link
							href={`#${item.target}`}
							className={style.listItemLink}
							title={item.title}
						>
							{item.title}
						</Link>
					</li>
				))}
			</ol>
			{items.length > 5 && (
				<div className={style.buttonWrapper}>
					<ShowMoreLessButton
						anchorId="contentOutline"
						moreIsVisible={!isAllVisible}
						onClick={() => setIsAllVisible(!isAllVisible)}
					/>
				</div>
			)}
		</div>
	);
};
